import { Button, type ButtonProps, Skeleton, Stack, type SxProps, type Theme, Typography } from '@mui/material';
import isEmpty from 'lodash/isEmpty';

const DashboardCard = ({
    children,
    title,
    subtitle,
    sx,
    buttonProps,
    isLoading,
    spacing = 1.5,
    number,
    secondaryButtonProps,
    headerRightContent,
    ...props
}: {
    title?: string;
    subtitle?: React.ReactNode;
    children?: React.ReactNode;
    sx?: SxProps;
    buttonProps?: ButtonProps;
    isLoading?: boolean;
    spacing?: number;
    number?: React.ReactNode;
    secondaryButtonProps?: ButtonProps;
    headerRightContent?: React.ReactNode;
}) => {
    return (
        <Stack
            direction='column'
            spacing={spacing}
            sx={{
                border: (t: Theme) => `1px solid ${t.palette.divider}`,
                p: 2,
                backgroundColor: '#FFFFFF',
                height: '100%',
                ...sx,
            }}
            {...props}
        >
            {(title || headerRightContent) && (
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography color='primary' variant='h6'>
                        {title}
                    </Typography>
                    {headerRightContent && headerRightContent}
                </Stack>
            )}
            {number !== undefined && (
                <Typography color='primary' variant='h4'>
                    {isLoading ? <Skeleton variant='text' width='60%' height={40} /> : number}
                </Typography>
            )}
            {subtitle !== undefined && (
                <Typography color='primary.mui.inactive' variant='subtitle2'>
                    {isLoading ? <Skeleton variant='text' width='70%' /> : subtitle}
                </Typography>
            )}
            {children}
            {(!isEmpty(buttonProps) || !isEmpty(secondaryButtonProps)) && (
                <Stack direction='row' spacing={1}>
                    {!isEmpty(secondaryButtonProps) && (
                        <Button
                            disabled={isLoading}
                            {...secondaryButtonProps}
                            variant={secondaryButtonProps.variant || 'outlined'}
                            color={secondaryButtonProps.color || 'primary'}
                            sx={{ width: 'fit-content', ...secondaryButtonProps.sx }}
                        />
                    )}
                    {!isEmpty(buttonProps) && (
                        <Button
                            disabled={isLoading}
                            {...buttonProps}
                            variant={buttonProps.variant || 'contained'}
                            color={buttonProps.color || 'primary'}
                            sx={{ width: 'fit-content', ...buttonProps.sx }}
                        />
                    )}
                </Stack>
            )}
        </Stack>
    );
};

export default DashboardCard;
